import { B2bDeductionInfoSpouseComponentPath } from 'app/core/workflow/page-path/statement-page-path/b2b.deduction-info-spouse-component.path';
import { DeductionInfoSpouseComponentPath } from 'app/core/workflow/page-path/statement-page-path/deduction-info-spouse-component.path';
import { WorkflowDeductionBaseService } from 'app/core/workflow/workflow-steps/deduction/workflow-deduction-base.service';
import {
  WorkflowDeductionInfoSpouseInsuranceService
} from 'app/core/workflow/workflow-steps/deduction/spouse/sub/workflow-deduction-info-spouse-insurance.service';
import {
  WorkflowDeductionInfoSpouseWorkAndOfficeService
} from 'app/core/workflow/workflow-steps/deduction/spouse/sub/workflow-deduction-info-spouse-work-and-office.service';

export class WorkflowDeductionInfoSpouseService extends WorkflowDeductionBaseService {
  public get isRequired(): boolean {
    return !!this.statement && this.hasSpouseAndFilledTogether
      && this.isDeductionOptionAdd;
  }

  public get isDone(): boolean {
    return this.statement && this.statement.spouse && this.statement.spouse.stageDeductionInfo;
  }

  public get isFakeStep(): boolean {
    return !this.isBusiness;
  }

  public get isVisible(): boolean {
    return this.isRequired
      && this.isDeductionRoute;
  }

  public get isActiveOnStepsBar(): boolean {
    const locationHref = window.location.href;

    return locationHref.search(B2bDeductionInfoSpouseComponentPath.regex()) !== -1
      || locationHref.search(DeductionInfoSpouseComponentPath.regex()) !== -1;
  }

  public get isActive(): boolean {
    if (this.isBusiness) {
      return this.defaultIsActiveFunction;
    }

    return false;
  }

  public get title(): string {
    return 'ASIDE_BAR.SPOUSES_DEDUCTION';
  }

  public get checkCanGo(): boolean {
    return !this.blockedDefaultWorkflow && this.isRequired && this.statement.stageDeductionInfo;
  }

  public get urlRegex(): RegExp {
    if (this.isBusiness) {
      return B2bDeductionInfoSpouseComponentPath.regex();
    }

    return DeductionInfoSpouseComponentPath.regex();
  }

  public get url(): string {
    if (this.isBusiness) {
      return B2bDeductionInfoSpouseComponentPath.url(this.getStatementId, this.getSpouseId);
    }

    return DeductionInfoSpouseComponentPath.url(
      this.getStatementId,
      this.getSpouseId,
      this.spouseHasEmployers
        ? WorkflowDeductionInfoSpouseWorkAndOfficeService._subStepNumber
        : WorkflowDeductionInfoSpouseInsuranceService._subStepNumber,
    );
  }

  public get stepClass(): string {
    let classes = this.classLeftLineNone;

    if (!this.isBusiness) {
      classes += this.classHasSubs;
    }

    return classes;
  }
}
